import React, { useEffect, useRef } from 'react'
import { Styles } from './styles/serviceBox'
import HeaderTwo from './HeaderTwo'
import FooterTwo from './FooterTwo'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import img from '../politicalimgeas/cardscrolling/bg2.jpeg'
import DOMPurify from 'dompurify'
import YouTube from 'react-youtube'
import { GetApi } from '../services/CommonService2'
import { useState } from 'react'

function DevelopmentsInfo() {
    const history = useHistory()
    const data = useLocation()
    const scrollRef = useRef(null);
    const scrollIntervalRef = useRef(null);


    const [images,setImages]=useState([])
    useEffect(() => {
        // console.log("location", data.state);
        getData()

    }, [])

    useEffect(() => {
        const scroll = scrollRef.current;
        if (!scroll) return;
    
        let scrollAmount = 0;
        const scrollSpeed = 2;
        const scrollInterval = 45;
    
        const startScrolling = () => {
            scrollIntervalRef.current = setInterval(() => {
                if (scroll) {
                    scroll.scrollLeft += scrollSpeed;
                    scrollAmount += scrollSpeed;
    
                    if (scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth) {
                        // Ensure there is a first element before cloning
                        if (scroll.firstElementChild) {
                            const clonedNode = scroll.firstElementChild.cloneNode(true);
                            scroll.appendChild(clonedNode); // Clone only if it exists
                        }
                        scroll.scrollLeft = 0;
                        scrollAmount = 0;
                    }
                }
            }, scrollInterval);
        };
    
        const stopScrolling = () => {
            clearInterval(scrollIntervalRef.current);
        };
    
        startScrolling();
    
        scroll.addEventListener('mouseenter', stopScrolling);
        scroll.addEventListener('mouseleave', startScrolling);
    
        return () => {
            clearInterval(scrollIntervalRef.current);
            scroll.removeEventListener('mouseenter', stopScrolling);
            scroll.removeEventListener('mouseleave', startScrolling);
        };
    }, [images]);

    const goBack = () => {
        history.goBack();
    };

    const sanitizedData = (data) => {
        const sanitizedHtml = DOMPurify.sanitize(data)
        return { __html: sanitizedHtml }
    }

    const opts = {
        width: "100%",
        borderRadius: "2rem",
        playerVars: { autoplay: 0 },
        height: "280px"
    };
    const videoReady = (event) => {
        event.target.pauseVideo();
    };

    const getData = async () => {
        const reqparams = {
            pageno: "-1",
            query: { status: 'Active',developmentid:data.state.id },
        }

        const Response = await GetApi(reqparams, "DEVELOPMENTIMAGES")
        // console.log("Dev Response", Response);
        setImages(Response.data)
    }
    return (
        <>
            <HeaderTwo />
            <Styles>
                <section class="Constituency-content py-5">
                    <button className="btn btn-warning" onClick={goBack} style={{ position: "fixed", bottom: "20px", left: "10px", zIndex: 999, }}><i class="fa-solid fa-arrow-left"></i></button>
                    <div class="container">
                        <h1 class="fs-2 mb-3 fw-bold text-decoration-underline text-secondary text-center">{data?.state?.name}</h1>
                        <p dangerouslySetInnerHTML={sanitizedData(data?.state?.description)}></p>

                        <YouTube
                            videoId={data.state.videourl}
                            opts={opts}
                            onReady={videoReady}
                            style={{
                                marginTop:'20px',
                                marginRight:'auto',
                                marginLeft:'auto',
                                objectFit:'container',
                                justifyContent: 'center',
                                width:'70%',
                                height:'auto',
                                overflow:'hidden',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.57)',
                                transition: 'box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out',
                                borderRadius: "20px",
                            }}

                        />
                        <div className="scrolling" ref={scrollRef}>
                            {images.map((ele)=>{
                                return <img src={ele.image} alt="Image 1" />
                            })}
                        </div>
                    </div>


                </section>
            </Styles>
            <FooterTwo />
        </>
    )
}

export default DevelopmentsInfo